import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { SystemUser } from "@@/shared/users/system-user";
import type { UserId } from "@@/shared/users/user-id";
import type { Ticket } from "../ticket";
import {
    createTicketSocketEventBase,
    type TicketSocketEventBase,
} from "./ticket-socket-event-base";
import { createTicketSocketEventData } from "./ticket-socket-event-data";
import type { TicketSocketEventTypeName } from "./ticket-socket-event-type-name";

type TypeName = Extract<TicketSocketEventTypeName, "redeemed">;
type TicketRedeemedSocketEvent = TicketSocketEventBase<TypeName>;

const createTicketRedeemedSocketEvent = (params: {
    ticket: Ticket;
    triggeredBy: UserId | SystemUser;
    triggeredAt: IsoAndUnixTimestamp;
}): TicketRedeemedSocketEvent => {
    return createTicketSocketEventBase<TypeName>({
        for: [params.ticket._id],
        triggeredBy: params.triggeredBy,
        triggeredAt: params.triggeredAt,
        data: createTicketSocketEventData({}),
        type: "ticket:redeemed",
        tags: [],
    });
};
export { createTicketRedeemedSocketEvent };
export type { TicketRedeemedSocketEvent };
